const colors = {
    dark_red: '#773D3D',
    white: '#FFFFFF',
    light_pink: '#DD8D8D',
    pink: '#F47272',
    h1_red: '#512828',
    black: '#000000'
}

export default colors